import { useCallback, useState } from "react";

/** A button that copies `text` to the clipboard and briefly confirms. */
export function CopyButton({
  text,
  label = "Copy",
  copiedLabel = "Copied",
  className = "",
}: {
  text: string;
  label?: string;
  copiedLabel?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  const copy = useCallback(() => {
    const confirm = () => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    };
    try {
      navigator.clipboard.writeText(text).then(confirm, () => undefined);
    } catch {
      // Clipboard unavailable (insecure context): leave the label unchanged.
    }
  }, [text]);

  return (
    <button type="button" onClick={copy} className={className}>
      {copied ? copiedLabel : label}
    </button>
  );
}
